<template>
  <v-container v-if="$store.getters.user" class="test_red">
    <v-row no-gutters class="test_blue row-res">
      <v-col cols="3" class="test_yellow">
        <AvatarCustomer />
      </v-col>
      <v-col cols="9" class="test_purple">
        <v-container>
          <v-row>
            <v-col cols="12">
              <span
                class="customer-name"
                v-text="user.firstName + ' ' + user.lastName"
              />
            </v-col>
            <v-col cols="12" md="12" lg="12">
              <v-row>
                <v-col cols="12" md="6" lg="3">
                  <!-- Content for the first column -->
                  <p class="tag-title" v-text="$t('customerProfile.email')" />
                  <span class="tag-content" v-text="user.email" />
                </v-col>
                <v-col cols="12" md="6" lg="3">
                  <!-- Content for the second column -->
                  <p
                    class="tag-title"
                    v-text="$t('customerProfile.phoneNumber')"
                  />
                  <span class="tag-content" v-text="user.phone" />
                </v-col>
                <v-col v-if="user.campaignName" cols="12" md="6" lg="3">
                  <!-- Content for the third column -->
                  <p
                    class="tag-title"
                    v-text="$t('customerProfile.campaignName')"
                  />
                  <span class="tag-content" v-text="user.campaignName" />
                </v-col>
                <v-col v-if="user.campaignOffer" cols="12" md="6" lg="3">
                  <!-- Content for the fourth column -->
                  <p
                    class="tag-title"
                    v-text="$t('customerProfile.campaignOffer')"
                  />
                  <span class="tag-content" v-text="user.campaignOffer" />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <v-row no-gutters class="test_blue">
      <v-col cols="3" class="test_yellow"> </v-col>
      <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 9" class="test_purple">
        <v-container>
          <v-card style="margin-top: 30px; padding: 20px">
            <v-row justify="space-between">
              <v-card-title>{{ $store.getters.appInfo.appName }}</v-card-title>
              <v-card-title>DKK {{ user.credits }}</v-card-title>
            </v-row>
            <p style="margin-left: 5px">
              {{ $t("customerProfile.creditDesc") }}
            </p>
          </v-card>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import AvatarCustomer from "./AvatarCustomer.vue";
export default {
  name: "PersonalInfo",
  components: {
    AvatarCustomer,
  },
  computed: {
    ...mapGetters(["user"]),
  },
};
</script>
<style lang="scss" scoped>
.customer-name {
  font-size: 2.5rem !important;
  font-family: $font_Bold;
}
.tag-title {
  font-size: 1.5rem !important;
  font-family: $font_Bold;
  line-height: 0px;
}
.tag-content {
  font-size: 1.2rem !important;
}
.row-res {
}
@media only screen and (min-width: 320px) and (max-width: 479px) {
  .customer-name {
    font-size: 1.5rem !important;
  }
  .tag-title {
    font-size: 1rem !important;
  }
  .tag-content {
    font-size: 0.9rem !important;
  }
}
@media only screen and (min-width: 320px) and (max-width: 829px) {
  .row-res {
    align-items: flex-start !important;
  }
}
</style>
